/* eslint-disable react/prop-types */
import React, { useState, useMemo } from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components/macro'
import { Button, Icon } from 'components/atoms'
import { useEditorContext, actions } from 'context/EditorContext';
import { removeBlock } from 'services/helpers'

const computeWrapperStyleFromType = (type) => {
  switch (type) {
  case 'VIDEO':
    return css`
      max-width: 555px;
    `
  case 'CAROUSEL':
    return css`
        display: flex;
      `
  default:
    return css``
  }
}

// handles editor logic for block level editing
const AtomicBlockWrapper = ({
  children, contentState, block,
}) => {
  const [isHover, setHover] = useState(false)
  const entityKey = useMemo(() => block.getEntityAt(0), [block])
  const entity = useMemo(() => contentState.getEntity(entityKey), [contentState, entityKey]);

  // const data = useMemo(() => entity.getData(), [entity]);
  const type = useMemo(() => entity.getType(), [entity]);
  const [{ richTextEditorState: editorState }, dispatch] = useEditorContext()

  // creates new editorState without the block
  // and dispatches the trigger action to update the state from the store
  const handleDelete = () => {
    const newEditorState = removeBlock({ editorState, contentState, block })
    dispatch({
      type: actions.RICH_TEXT_EDITOR_STATE_TRIGGER,
      data: newEditorState,
    });
  }

  return (
    <Wrapper onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)} type={type}>
      <Block>
        {isHover && <Actions onDelete={handleDelete} />}
        <RemovePointerEventsAndFixSpacing>
          {children}
        </RemovePointerEventsAndFixSpacing>
      </Block>
    </Wrapper>
  )
}

const Wrapper = styled.div(props => css`
  ${computeWrapperStyleFromType(props.type)}
`)

const Block = styled.div`
  position: relative;
`

const ActionsWrapper = styled.div(props => css`
  position: absolute;
  z-index: ${props.theme.values.zIndex.s};
  transform: translateY(-100%);
  right: 0;
`)

const RemovePointerEventsAndFixSpacing = styled.div`
  margin: 0 !important;
  pointer-events: none;
  & > div {
    margin: 0 !important;
  }
`

const Actions = ({ onDelete = () => null }) => (
  <ActionsWrapper>
    <Button onClick={onDelete}><Icon icon="delete" height={16} /></Button>
  </ActionsWrapper>
)

AtomicBlockWrapper.propTypes = {
  block: PropTypes.shape({}).isRequired,
  contentState: PropTypes.shape({}).isRequired,
  children: PropTypes.node.isRequired,
}

export default AtomicBlockWrapper
